export default "__VITE_ASSET__cWKjhTSB__"